import { render } from "./WaSesionsView.vue?vue&type=template&id=3254aa6f"
import script from "./WaSesionsView.vue?vue&type=script&lang=js"
export * from "./WaSesionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__